export const formatDocument = (doc: string): string => {
    if (!doc) return '';
    const numbers = doc.replace(/\D/g, '');

    if (numbers.length === 11) {
        // CPF: 000.000.000-00
        return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else if (numbers.length === 14) {
        // CNPJ: 00.000.000/0000-00
        return numbers.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }

    return doc; // Return original if not 11 or 14 digits
};

export const formatDateSafely = (dateString?: string | null): string => {
    if (!dateString) return 'Sem data';
    try {
        // If it's a T-separated ISO string (e.g., 2023-10-27T00:00:00.000Z), take the date part
        const datePart = dateString.includes('T') ? dateString.split('T')[0] : dateString;
        
        // Handle YYYY-MM-DD format (typical ISO date)
        if (datePart.match(/^\d{4}-\d{2}-\d{2}$/)) {
            const [year, month, day] = datePart.split('-');
            return `${day}/${month}/${year}`;
        }

        // Fallback to native parsing for other formats, but try to avoid UTC shifts
        // By replacing - with / in strings that LOOK like dates, native Date constructor 
        // treats them as local time instead of UTC in many browsers.
        const normalizedDate = dateString.replace(/-/g, '/');
        const d = new Date(normalizedDate);
        
        if (isNaN(d.getTime())) {
            // Last resort: native parsing
            const dRaw = new Date(dateString);
            if (isNaN(dRaw.getTime())) return 'Data Inválida';
            return dRaw.toLocaleDateString('pt-BR');
        }
        
        return d.toLocaleDateString('pt-BR');
    } catch (e) {
        return 'Data Inválida';
    }
};

